import React from 'react';
import PropTypes from 'prop-types';
import {
  Cushion,
  FlexContainer,
  MaxWidth,
  Rectangle,
  Shadow,
  Show,
  Space,
  Typography,
} from '@pitchero/react-ui';
import { get } from 'lodash';
import NoBackground from '../club-frame/header/no-background';
import Comments from '../comments/dynamic';
import PhotoGrid from '../media/photo-grid';
import SeoHead from '../seo';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { Trans } from '../../lib/i18n';
import UploadButton from '../media/upload-button';
import AlbumLoadingState from './album-loading';

const Album = ({ album, club, title }) => (
  <>
    <SeoHead
      club={club}
      descriptionTranslationKey="media:album_meta_description"
      route="media.album"
      routeParams={{ _title: title, id: album && album.id }}
      title={title}
      translationValues={{
        authorName: get(album, 'author.name'),
        imageCount: get(album, 'images', []).length,
      }}
    />
    <NoBackground />
    <Shadow>
      <Rectangle fill="white" borderBottom="thinLightGrey">
        <Cushion vertical="small" left="medium" component="div">
          <Space vertical="small">
            <MaxWidth component="div" maxWidth={1366} center>
              <FlexContainer direction="row" justifyContent="space-between">
                <Rectangle>
                  <Space bottom="xsmall">
                    <Typography component="h1" preset="title">
                      {title}
                    </Typography>
                  </Space>
                  {album && album.author && (
                    <Typography component="div" preset="tag--large" color="dustygrey">
                      <Trans i18nKey="by_author" values={{ author: album.author.name }}>
                        By &nbsp;
                        {album.author.name}
                      </Trans>
                    </Typography>
                  )}
                </Rectangle>
                <Show minWidth="tab">
                  <Space right="xlarge" component="div">
                    <UploadButton fullWidth mediaType="albums">
                      <Trans i18nKey="media:upload_albums">Upload Albums</Trans>
                    </UploadButton>
                  </Space>
                </Show>
              </FlexContainer>
            </MaxWidth>
          </Space>
        </Cushion>
      </Rectangle>
    </Shadow>

    <Cushion vertical="medium">
      <MaxWidth component="div" maxWidth={1366} center>
        {album ? (
          <>
            <PhotoGrid albumId={album.id} images={album.images} />

            {club.commentsEnabled && (
              <Space top="xlarge">
                <Typography preset="subtitle--large" component="h3">
                  <Trans i18nKey="common:comments_title">Comments</Trans>
                </Typography>
                <Comments club={club} mediaType="album" mediaId={album.id} />
              </Space>
            )}
          </>
        ) : (
          <AlbumLoadingState />
        )}
      </MaxWidth>
    </Cushion>
  </>
);

Album.defaultProps = {
  album: null,
};

Album.propTypes = {
  album: PropTypes.shape({
    author: PropTypes.shape({
      name: PropTypes.string,
    }),
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ),
  }),
  club: CLUB_PROP_TYPES.isRequired,
  title: PropTypes.string.isRequired,
};

export default Album;
